import React from 'react';

import LocaleDatePickerCore, { Props } from '@travel/traveler-core/components/LocaleDatePicker';

function LocaleDatePicker(props: Props & { className?: string }) {
  return <LocaleDatePickerCore {...props} />;
}

export default LocaleDatePicker;
